import { AuxGridColumnType } from "@blk/aladdin-web-components";
import { addCustomFieldsAsCols, addCustomFieldsAsDatapoints } from "../../helper";
import { PortfolioCreationChoice } from "../../types";
import { DatapointIdStandardEnum } from "api/ux/src";
import { InsGridAggs } from "components/widgets/grid/grid-agg-funcs";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { getMeasuresAndDimensionsWithCurrency } from "hooks/use-funds-page";
import { useGetCustomDatapointDimensionsByPortfolioCreationChoice } from "hooks/widget-data/use-datapoints";
import { language } from "language/default";
import { AddInvestorAccountsOrFundsMode } from "store/modal/portfolio-creation-types";
const { assetClass } = language.en;
export const getMeasuresAndDimensions = (customFields, mode) => {
    let datapoints = [];
    if (mode === AddInvestorAccountsOrFundsMode.AddInvestorAccounts) {
        datapoints = [
            { datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "Id" },
            { datapoint: { standard: DatapointIdStandardEnum.FundInvestorId }, name: "InvestorId" },
            { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "Name" },
            { datapoint: { standard: DatapointIdStandardEnum.FundCurrency }, name: "Currency" },
            { datapoint: { standard: DatapointIdStandardEnum.FundInvestorName }, name: "InvestorName" },
            { datapoint: { standard: DatapointIdStandardEnum.FundInvestorCurrency }, name: "InvestorCurrency" },
            { datapoint: { standard: DatapointIdStandardEnum.FundManagerName }, name: "ManagerName" },
            { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "Vintage" },
            { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy" },
            { datapoint: { standard: DatapointIdStandardEnum.FundGeography }, name: "Geography" },
            { datapoint: { standard: DatapointIdStandardEnum.FundCommitment }, name: "Commitment" },
            { datapoint: { standard: DatapointIdStandardEnum.FundInvestorStartDate }, name: "Commitment Date" },
            { datapoint: { standard: DatapointIdStandardEnum.FundAssetClass }, name: "Asset Class" }
        ];
    }
    else {
        datapoints = [
            { datapoint: { standard: DatapointIdStandardEnum.FundFundId }, name: "Id" },
            { datapoint: { standard: DatapointIdStandardEnum.FundFundName }, name: "Name" },
            { datapoint: { standard: DatapointIdStandardEnum.FundAssetClass }, name: "Asset Class" },
            { datapoint: { standard: DatapointIdStandardEnum.FundManagerName }, name: "ManagerName" },
            { datapoint: { standard: DatapointIdStandardEnum.FundVintageYear }, name: "Vintage" },
            { datapoint: { standard: DatapointIdStandardEnum.FundStrategy }, name: "Strategy" },
            { datapoint: { standard: DatapointIdStandardEnum.FundGeography }, name: "Geography" },
            { datapoint: { standard: DatapointIdStandardEnum.FundCurrency }, name: "Currency" },
            { datapoint: { standard: DatapointIdStandardEnum.FundSize }, name: "FundSize" },
            { datapoint: { standard: DatapointIdStandardEnum.FundReportedCommitment }, name: "Commitment" },
            { datapoint: { standard: DatapointIdStandardEnum.FundCommitmentDate }, name: "Commitment Date" }
        ];
    }
    addCustomFieldsAsDatapoints(customFields, datapoints);
    return getMeasuresAndDimensionsWithCurrency(["InvestorId", "Id"], datapoints);
};
export const getColIdsForInvestorAccountsOrFunds = (customFields, mode) => {
    let cols = [];
    if (mode === AddInvestorAccountsOrFundsMode.AddInvestorAccounts) {
        cols = [
            { field: "Id", hide: true, lockVisible: true },
            { field: "InvestorId", hide: true, lockVisible: true },
            {
                checkboxSelection: true,
                field: "checkboxCol",
                floatingFilter: false,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                headerName: " ",
                type: AuxGridColumnType.AUX_CHECKBOX_COLUMN,
                width: 32
            },
            { field: "Name", headerName: language.en.modal.portfolioCreation.grid.fundName, sort: "asc", type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "Currency", headerName: language.en.modal.portfolioCreation.grid.fundCurrency, type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
            { field: "InvestorName", headerName: language.en.modal.portfolioCreation.grid.investorAccount, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "InvestorCurrency", headerName: language.en.modal.portfolioCreation.grid.investorCurrency, type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
            { aggFunc: InsGridAggs.totalData,
                field: "Commitment",
                headerName: language.en.modal.portfolioCreation.grid.commitment,
                type: [CustomColumnType.InsMoneyColumn],
                width: 120 },
            { field: assetClass.gridTitle, type: CustomColumnType.AUX_TEXT_COLUMN, width: 120 },
            { field: "ManagerId", headerName: language.en.modal.portfolioCreation.grid.manager, hide: true, lockVisible: true, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "ManagerName", headerName: language.en.modal.portfolioCreation.grid.manager, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "Vintage", headerName: language.en.modal.portfolioCreation.grid.vintage, type: CustomColumnType.InsNumberSetColumn, width: 80 },
            { field: "Strategy", headerName: language.en.modal.portfolioCreation.grid.strategy, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "Geography", headerName: language.en.modal.portfolioCreation.grid.geography, type: CustomColumnType.AUX_TEXT_COLUMN }
        ];
    }
    else {
        cols = [
            { field: "Id", hide: true, lockVisible: true },
            {
                checkboxSelection: true,
                field: "checkboxCol",
                floatingFilter: false,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                headerName: " ",
                type: AuxGridColumnType.AUX_CHECKBOX_COLUMN,
                width: 32
            },
            { field: "Name", headerName: language.en.modal.portfolioCreation.grid.fundName, sort: "asc", type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: assetClass.gridTitle, type: CustomColumnType.AUX_TEXT_COLUMN, width: 120 },
            { field: "ManagerName", headerName: language.en.modal.portfolioCreation.grid.manager, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "Vintage", headerName: language.en.modal.portfolioCreation.grid.vintage, type: CustomColumnType.InsNumberSetColumn, width: 80 },
            { field: "Strategy", headerName: language.en.modal.portfolioCreation.grid.strategy, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "Geography", headerName: language.en.modal.portfolioCreation.grid.geography, type: CustomColumnType.AUX_TEXT_COLUMN },
            { field: "Currency", headerName: language.en.modal.portfolioCreation.grid.fundCurrency, type: CustomColumnType.AUX_TEXT_COLUMN, width: 80 },
            { field: "Commitment", hide: true, lockVisible: true },
            { aggFunc: InsGridAggs.totalData,
                field: "FundSize",
                headerName: language.en.modal.portfolioCreation.grid.fundSize,
                type: [CustomColumnType.InsMoneyColumn],
                width: 120 },
            { field: "ManagerId", headerName: language.en.modal.portfolioCreation.grid.manager, hide: true, lockVisible: true, type: CustomColumnType.AUX_TEXT_COLUMN }
        ];
    }
    addCustomFieldsAsCols(customFields, cols);
    return cols;
};
export const useCustomDatapointDimensions = (mode) => {
    const portfolioCreationChoice = mode === AddInvestorAccountsOrFundsMode.AddInvestorAccounts
        ? PortfolioCreationChoice.CreatePortfolioManualCompositionInvestorAccounts
        : PortfolioCreationChoice.CreatePortfolioManualCompositionFunds;
    return useGetCustomDatapointDimensionsByPortfolioCreationChoice(portfolioCreationChoice);
};
